import React, { useEffect, useRef } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/ic-exit-rounded-purple.svg';
import { ReactComponent as AlertIcon } from '../../assets/images/psp/alert.svg';
import { Button } from '../UI-CHAKRA/Button';

interface PbmErrorStepProps {
  onClose: () => void;
  onEventEmission: (eventName: string, eventData: Record<string, unknown>) => void;
}

const PbmErrorStep: React.FC<PbmErrorStepProps> = ({ onClose, onEventEmission }) => {
  const hasEmittedViewEventRef = useRef(false);

  useEffect(() => {
    if (hasEmittedViewEventRef.current) return;
    hasEmittedViewEventRef.current = true;
    onEventEmission('backoffice_campaign_pbm_consent_click', {
      flow: 'consentimento',
      concluiuPreCadastro: false,
      statusEnvio: 'error',
    });
  }, [onEventEmission]);

  return (
    <Flex flexDirection={'column'} height={'100%'} overflow="hidden">
      <Box flexShrink={0} borderBottom={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} padding={'20px'}>
          <Text fontSize={'18px'} fontWeight={700} color={'#343A40'}>
            Programa de Benefício em Medicamentos
          </Text>
          <CloseIcon onClick={onClose} cursor={'pointer'} />
        </Flex>
      </Box>

      <Box flexGrow={1} overflowY={'auto'} overflowX="hidden" padding={'120px 15px 15px 15px'}>
        <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={'24px'} minH={'400px'}>
          <Box
            width={'150px'}
            height={'150px'}
            borderRadius={'50%'}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <AlertIcon width={'150px'} height={'150px'} />
          </Box>

          <Text fontSize={'32px'} fontWeight={700} color={'primary.main'} textAlign={'center'}>
            Não foi possível concluir <br></br>o cadastro
          </Text>

          <Text fontSize={'14px'} color={'#3D0E6B'} textAlign={'center'} maxW={'400px'}>
            Estamos com instabilidade na conexão com o programa. O cadastro não pôde ser concluído, mas a receita pode
            ser emitida normalmente.
          </Text>
        </Flex>
      </Box>

      <Box flexShrink={0} padding={'20px'} borderTop={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} gap={'12px'} justifyContent={'flex-end'}>
          <Button
            onClick={onClose}
            padding="10px 20px"
            backgroundColor={'#FFF'}
            borderWidth={'2px'}
            borderColor={'primary.main'}
            borderStyle={'solid'}
            borderRadius={'20px'}
            _hover={{ backgroundColor: '#FFF', borderColor: '#6B409C' }}
          >
            <Text fontSize={'14px'} color={'primary.main'}>
              Fechar
            </Text>
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default PbmErrorStep;
